import axios from "axios";
import { API_ROOT } from ".";

const EVENT_TICKETS_API_URL = `${API_ROOT}/event-tickets`;

export const EVENT_TICKET_COMMENT_MAX_LENGTH = 150;

export async function createEventTicketCheckoutSession(
  eventId: string,
  quantity: number,
  comment = "",
): Promise<{ checkoutUrl: string | null; sessionId: string }> {
  const res = await axios.post<{ checkoutUrl: string | null; sessionId: string }>(
    `${EVENT_TICKETS_API_URL}/checkout-session`,
    {
      eventId,
      quantity,
      comment: comment.trim().slice(0, EVENT_TICKET_COMMENT_MAX_LENGTH),
    },
  );
  return res.data;
}
